export enum EmailHelper {
  error = 'Email введен некорректно',
  required = 'Email - обязательное поле',
  ok = '',
}
